export default __webpack_public_path__ + "static/favicon-base-834be9f12c5557011a34d1c77830b014.png";